import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import CartProvider from "../context/CartContext";
import SearchProvider from "../context/SearchContext";

import imgOnlineOrderBg from "../../assets/images/online-order-bg.jpg";


// import "../../assets/niceshop/vendor/bootstrap/css/bootstrap.min.css";
import "../../assets/niceshop/vendor/bootstrap-icons/bootstrap-icons.css";
// import "../../assets/niceshop/vendor/swiper/swiper-bundle.min.css";
// import "../../assets/niceshop/vendor/aos/aos.css";
// import "../../assets/niceshop/vendor/glightbox/css/glightbox.min.css";
// import "../../assets/niceshop/vendor/drift-zoom/drift-basic.css";

import BkEndLoginProvider from "../../Login/Login";
import LoginProvider from "../context/LoginContext";

import "../../assets/niceshop/css/main.css";

export default function Layout({children}){
    // useEffect(_=>{

    // })
    return <div 
        style={{
            "background":`url(${imgOnlineOrderBg}) gray`,
            "width":"100hw",
            "height":"100vh",
            "backgroundRepeat": "no-repeat",
            "backgroundSize": "cover"
        }}
    >
        <BkEndLoginProvider
            username={"martin"}
            password={"letmein"}
        >
            <LoginProvider>
                <SearchProvider>
                    <CartProvider>
                        <Header></Header>
                        <main>
                            {children}
                        </main>
                        <Footer></Footer>
                    </CartProvider>
                </SearchProvider>
            </LoginProvider>
        </BkEndLoginProvider>        
    </div>;
}